<template>
  <div class="Jobfairindex">
<!--    <div class="table1">
      <div class="tableSpan">
        <span @click="handleRolemanagement">管理员列表</span>
        <span class="spanColor">角色管理</span>
      </div>
    </div> -->
    <div class="operation-tool">
      <div @click="handleAdminindexAdd('')" class="tool-item"> <img src="../../../static/img/btn/add.png" /> 添加角色</div>
    </div>
 <div class="l-panel">
          <div class="panel-body">
      <el-table class="l-table" stripe="" ref="multipleTable" :data="tableData" style="width: 100%" >
        <el-table-column prop="name" label="角色名称" align="left">
          <template slot-scope="{ row }">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="角色描述" align="left" width="350"> </el-table-column>
        <el-table-column prop="deparment_name" label="部门" align="left"> </el-table-column>
        <el-table-column prop="ordid" label="排序" align="left"> </el-table-column>
        <el-table-column prop="last_login_time" label="状态" align="left">
          <template slot-scope="{ row }">
            <span v-if="row.status == 1" style="color:#009933">激活</span>
            <span v-if="row.status == 0">非激活</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="操作" align="left">
          <template slot-scope="{ row }">

              <el-button type="primary" size="mini" plain @click="handleAuthorization(row)">授权</el-button>
              <el-button type="primary" size="mini" plain @click="handleAdminindexAdd(row.id)">修改</el-button>
              <el-button size="mini" plain @click="handledele(row.id)" v-if="row.id !=1">删除</el-button>

          </template>
        </el-table-column>
      </el-table>
      <div class="c-table-pager">
        <el-pagination @current-change="handleCurrentChange" :page-size="10"  :total="total">
        </el-pagination>
      </div>

      </div>
    </div>

  </div>
</template>

<script>
  import {
    Message
  } from "element-ui";
  export default {
    data() {
      return {
        info: {
          page: 1
        },
        options: [],
        total: 1,
        tableData: [],
        Selection_id: "",
        projectModel: true
      };
    },
    activated() {
      this.getData();
      this.gets("public/rolelist").then((res) => {
        this.options = res.data.data
      });
    },
    methods: {
      handleAuthorization(row) {
        this.$router.push({
          path: '/authorization?id=' +  row.id + "&pName="+row.name + "&department=" + row.deparment_name
        })
      },
      handleRolemanagement() {
        this.$router.push({
          path: '/Adminindex'
        })
      },
      //删除
      handledele(id) {
        this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          })
          .then(() => {
            this.gets("adminrole/delete?id=" + id).then((res) => {
              if (res.data.code == 1) {
                Message.success(res.data.msg);
                this.getData();
              } else {
                Message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      },

      handleAdminindexAdd(id) {
        console.log(id);
        if (id) {
          var ids = id;
        } else {
          var ids = "";
        }
        this.$router.push({
          path: "/roleAdd?id=" + ids,
        });
      },
      handleSeach() {
        this.info.page = 1;
        this.getData();
      },
      //分页
      handleCurrentChange(val) {
        this.info.page = val;
        this.getData();
      },
      getData() {
        this.gets("adminrole/index", this.info).then((res) => {

          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
        });
      },
    },
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/system/rolemanagement.vue